const formConfig = {
    "Letter of Credit (LC) - Sight / Usance / Back-to-Back": {
      mandatoryFields: [
        "applicantName",
        "beneficiaryName",
        "lcAmount",
        "lcCurrency",
        "lcType",
        "incoterm",
        "countryOrigin",
        "countryDestination",
        "goodsDescription",
        "expiryDate",
        "paymentTerms",
        "tradeType",
        "commodityDescription",
        "portLoading",
        "portDischarge",
        "requiredDocuments",
      ],
      visibleFields: [
        "applicantName",
        "beneficiaryName",
        "lcAmount",
        "lcCurrency",
        "lcType",
        "lcTenor", // Conditionally visible based on lcType
        "incoterm",
        "countryOrigin",
        "countryDestination",
        "goodsDescription",
        "lcOpeningBankDetails",
        "expiryDate",
        "paymentTerms",
        "tradeType",
        "commodityDescription",
        "hsCode",
        "buyerNameCountry",
        "sellerNameCountry",
        "portLoading",
        "portDischarge",
        "shipmentDate",
        "tradeValue",
        "advisingConfirmingBankRequired",
        "confirmationRequired",
        "partialShipmentAllowed",
        "transshipmentAllowed",
        "instrumentTerms",
        "issuanceCharges",
        "confirmationCharges",
        "interestRateMargin",
        "tenorOffered",
        "advisingConfirmingBank",
        "requiredDocuments",
        "additionalDocuments",
        "specialConditions",
        "proformaInvoiceFile",
        "tradeDocsFile",
        "kycDocsFile",
        "responseDeadline",
        "preferredFinancingRateType",
        "maximumAcceptableCharges",
        "additionalComments",
      ],
      conditionalFields: {
        lcTenor: (formData) => formData.lcType === "Usance",
      },
    },
    "Deferred Payment Terms with LC": {
      mandatoryFields: [
        "applicantName",
        "beneficiaryName",
        "lcAmount",
        "lcCurrency",
        "lcType",
        "incoterm",
        "countryOrigin",
        "countryDestination",
        "goodsDescription",
        "expiryDate",
        "paymentTerms",
        "tradeType",
        "commodityDescription",
        "portLoading",
        "portDischarge",
        "requiredDocuments",
      ],
      visibleFields: [
        "applicantName",
        "beneficiaryName",
        "lcAmount",
        "lcCurrency",
        "lcType",
        "lcTenor", // Conditionally visible based on lcType
        "incoterm",
        "countryOrigin",
        "countryDestination",
        "goodsDescription",
        "lcOpeningBankDetails",
        "expiryDate",
        "paymentTerms",
        "tradeType",
        "commodityDescription",
        "hsCode",
        "buyerNameCountry",
        "sellerNameCountry",
        "portLoading",
        "portDischarge",
        "shipmentDate",
        "tradeValue",
        "advisingConfirmingBankRequired",
        "confirmationRequired",
        "partialShipmentAllowed",
        "transshipmentAllowed",
        "instrumentTerms",
        "issuanceCharges",
        "confirmationCharges",
        "interestRateMargin",
        "tenorOffered",
        "advisingConfirmingBank",
        "requiredDocuments",
        "additionalDocuments",
        "specialConditions",
        "proformaInvoiceFile",
        "tradeDocsFile",
        "kycDocsFile",
        "responseDeadline",
        "preferredFinancingRateType",
        "maximumAcceptableCharges",
        "additionalComments",
      ],
      conditionalFields: {
        lcTenor: (formData) => formData.lcType === "Usance",
      },
    },
    "Bank Guarantee (BG) - Payment / Performance": {
      mandatoryFields: [
        "applicantName",
        "beneficiaryName",
        "lcAmount",
        "lcCurrency",
        "lcType",
        "expiryDate",
        "buyerNameCountry",
        "sellerNameCountry",
        "GuaranteeType",
        "GuaranteeAmount",
        "GuaranteeValidityDate",
        "ClaimExpiryDate",
        "ClaimProcessInstructions",
        "UnderlyingContractRef",
        "requiredDocuments",
        "responseDeadline",
        "maximumAcceptableCharges",
        "additionalComments",
        "issuanceCharges",
      ],
      visibleFields: [
        "applicantName",
        "beneficiaryName",
        "lcAmount",
        "lcCurrency",
        "lcType",
        "goodsDescription",
        "expiryDate",
        "paymentTerms",
        "buyerNameCountry",
        "sellerNameCountry",
        "issuanceCharges",
        "requiredDocuments",
        "additionalDocuments",
        "specialConditions",
        "proformaInvoiceFile",
        "tradeDocsFile",
        "kycDocsFile",
        "responseDeadline",
        "preferredFinancingRateType",
        "maximumAcceptableCharges",
        "additionalComments",
        "GuaranteeType",
        "GuaranteeAmount",
        "GuaranteeValidityDate",
        "ClaimExpiryDate",
        "ClaimProcessInstructions",
        "CounterGuarantee",
        "UnderlyingContractRef",
        // "TriggerConditions",
        // "ExpiryEvent",
        // "CollectionMethod",
        // "CollectingBank",
        // "AcceptanceTerms",
        // "PaymentDueDate",
        // "InsuranceCoveragePercent",
        // "PremiumAmountTerms",
        // "PolicyPeriod",
        // "EscrowAgentOrBank",
        // "EscrowAmount",
        // "ReleaseConditions",
        // "CreditLimit",
        // "LatePaymentPenalty",
      ],
      conditionalFields: {},
    },
    "Standby Letter of Credit (SBLC)": {
      mandatoryFields: [
        "applicantName",
        "beneficiaryName",
        "lcAmount",
        "lcCurrency",
        "lcType",
        "lcOpeningBankDetails",
        "expiryDate",
        "paymentTerms",
        "tenorOffered",
        "interestRateMargin",
        "requiredDocuments",
        "ClaimExpiryDate",
        "ClaimProcessInstructions",
        "UnderlyingContractRef",
        "TriggerConditions",
        "ExpiryEvent",
      ],
      visibleFields: [
        "applicantName",
        "beneficiaryName",
        "lcAmount",
        "lcCurrency",
        "lcType",
        "goodsDescription",
        "lcOpeningBankDetails",
        "expiryDate",
        "paymentTerms",
        "buyerNameCountry",
        "sellerNameCountry",
        "tradeValue",
        "advisingConfirmingBankRequired",
        "confirmationRequired",
        "instrumentTerms",
        "issuanceCharges",
        "confirmationCharges",
        "interestRateMargin",
        "tenorOffered",
        "advisingConfirmingBank",
        "requiredDocuments",
        "additionalDocuments",
        "specialConditions",
        "proformaInvoiceFile",
        "tradeDocsFile",
        "kycDocsFile",
        "responseDeadline",
        "preferredFinancingRateType",
        "maximumAcceptableCharges",
        "additionalComments",
        "GuaranteeType",
        "GuaranteeAmount",
        "GuaranteeValidityDate",
        "ClaimExpiryDate",
        "ClaimProcessInstructions",
        "CounterGuarantee",
        "UnderlyingContractRef",
        "TriggerConditions",
        "ExpiryEvent",
        // "CollectionMethod",
        // "CollectingBank",
        // "AcceptanceTerms",
        // "PaymentDueDate",
        // "InsuranceCoveragePercent",
        // "PremiumAmountTerms",
        // "PolicyPeriod",
        // "EscrowAgentOrBank",
        // "EscrowAmount",
        // "ReleaseConditions",
        // "CreditLimit",
        // "LatePaymentPenalty",
      ],
      conditionalFields: {},
    },
    "Buyer's Credit / Trade Loan": {
      mandatoryFields: [],
      visibleFields: [],
      conditionalFields: {},
    },
    "Documentary Collection (D/P or D/A)": {
      mandatoryFields: [],
      visibleFields: [],
      conditionalFields: {},
    },
    "Open Account with Credit Insurance": {
      mandatoryFields: [],
      visibleFields: [],
      conditionalFields: {},
    },
  };
  
  export default formConfig;